"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageNumForm = PageNumForm;
exports.PageNumSuite = PageNumSuite;
var react_1 = __importStar(require("react"));
var grid_ctx_1 = require("../contexts/grid_ctx");
function PageNumForm() {
    var _a = (0, react_1.useContext)(grid_ctx_1.GridContext), pageNum = _a.pageNum, gotoPageNum = _a.gotoPageNum, totalPageNum = _a.totalPageNum;
    var _b = (0, react_1.useState)("".concat(pageNum)), inputValue = _b[0], setInputValue = _b[1];
    (0, react_1.useEffect)(function () {
        setInputValue("".concat(pageNum));
    }, [pageNum]);
    var handleSubmit = function (e) {
        e.preventDefault();
        var num = Number(inputValue);
        if (!isNaN(num) && num >= 1 && num <= totalPageNum) {
            gotoPageNum(num);
        }
    };
    return (react_1.default.createElement("form", { className: "zmsk-pagenum", onSubmit: handleSubmit },
        "Page",
        react_1.default.createElement("input", { type: "text", pattern: "[0-9]*", className: "zmsk-input", min: 1, max: totalPageNum, value: inputValue, onChange: function (e) { return setInputValue(e.target.value); }, placeholder: "", onKeyDown: function (e) {
                if (e.key === "Enter") {
                    handleSubmit(e);
                }
            } }),
        "/ ",
        totalPageNum,
        react_1.default.createElement("button", { className: "zmsk-button", type: "submit" }, "Go")));
}
function PageNumSuite() {
    var gotoNextPage = (0, react_1.useContext)(grid_ctx_1.GridContext).gotoNextPage;
    function prevPage() {
        gotoNextPage(-1);
    }
    function nextPage() {
        gotoNextPage(1);
    }
    return (react_1.default.createElement("div", { className: "zmsk-pagenum-suite" },
        react_1.default.createElement("button", { className: "zmsk-button", onClick: prevPage }, "Prev Page"),
        react_1.default.createElement(PageNumForm, null),
        react_1.default.createElement("button", { className: "zmsk-button", onClick: nextPage }, "Next Page")));
}
